import { CircleAlert } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { cn } from 'src/lib/utils';

type Props = {
  text: string;
  action: React.ReactNode;
  withAlertIcon?: boolean;
  className?: string;
};

const MigrationAlert = ({ text, action, withAlertIcon = true, className }: Props) => {
  return (
    <Alert
      className={cn(
        'bg-yellow-50 border-0 grid-cols-[1fr_auto] items-center gap-2 px-5 py-4 sticky top-0 z-10',
        withAlertIcon && 'grid-cols-[auto_1fr_auto]',
        className,
      )}
    >
      {withAlertIcon && (
        <div className="size-5 rounded-full border flex items-center justify-center bg-yellow-400 border-yellow-300">
          <CircleAlert className="size-4.5 text-white" strokeWidth={2} />
        </div>
      )}
      <AlertDescription className={cn('text-foreground flex items-center gap-2', !withAlertIcon && 'col-start-1')}>
        {text}
      </AlertDescription>
      <div className="col-span-3 sm:col-span-1">{action}</div>
    </Alert>
  );
};

export default MigrationAlert;
